<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M1.72998 22.27L15.73 17.27L6.72998 8.26998L1.72998 22.27ZM12.08 16.45L5.02998 18.97L7.54998 11.92L12.08 16.45Z"
      fill="url(#paint0_linear_5364_4516)"
    />
    <path
      d="M14.26 12.8L19.85 7.20998C20.34 6.71998 21.13 6.71998 21.62 7.20998L22.21 7.79998L23.27 6.73998L22.68 6.14998C21.61 5.07998 19.86 5.07998 18.79 6.14998L13.2 11.74L14.26 12.8Z"
      fill="url(#paint1_linear_5364_4516)"
    />
    <path
      d="M9.78998 7.14998L9.19998 7.73998L10.26 8.79998L10.85 8.20998C11.92 7.13998 11.92 5.38998 10.85 4.31998L10.26 3.72998L9.19998 4.79998L9.78998 5.38998C10.27 5.86998 10.27 6.66998 9.78998 7.14998Z"
      fill="url(#paint2_linear_5364_4516)"
    />
    <path
      d="M16.79 12.15L15.2 13.74L16.26 14.8L17.85 13.21C18.34 12.72 19.13 12.72 19.62 13.21L21.23 14.82L22.29 13.76L20.68 12.15C19.6 11.08 17.86 11.08 16.79 12.15Z"
      fill="url(#paint3_linear_5364_4516)"
    />
    <path
      d="M14.79 6.14998L11.2 9.73998L12.26 10.8L15.85 7.20998C16.92 6.13998 16.92 4.38998 15.85 3.31998L14.26 1.72998L13.2 2.78998L14.79 4.37998C15.27 4.86998 15.27 5.66998 14.79 6.14998Z"
      fill="url(#paint4_linear_5364_4516)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_4516"
        x1="1.72998"
        y1="1.72998"
        x2="22.3233"
        y2="23.1789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5364_4516"
        x1="1.72998"
        y1="1.72998"
        x2="22.3233"
        y2="23.1789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5364_4516"
        x1="1.72998"
        y1="1.72998"
        x2="22.3233"
        y2="23.1789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5364_4516"
        x1="1.72998"
        y1="1.72998"
        x2="22.3233"
        y2="23.1789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5364_4516"
        x1="1.72998"
        y1="1.72998"
        x2="22.3233"
        y2="23.1789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
